// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { loadCDLV3Script } from '@makemydeal/dr-common-data-layer-utils';

// interfaces/types
import { type DashMiddleware, type DashStore, type DashNext, initActionTypes } from '@makemydeal/dr-shared-store';
import { HostEnvironment, hostUrlHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

const { INIT_PENCIL_SUCCESS, INIT_PENCIL_INVALID_DEAL } = initActionTypes;

export const loadCdlV3ScriptMiddleware: DashMiddleware = (_store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    next(action);

    switch (action.type) {
        case INIT_PENCIL_SUCCESS:
        case INIT_PENCIL_INVALID_DEAL: {
            const environment = hostUrlHelper.getHostUrlEnvironment(MANAGER_VIEW_APP_PREFIX, locHrefUtil.getLocHref());
            const env = environment === HostEnvironment.Prod ? 'prod' : 'non-prod';
            loadCDLV3Script(env);
            break;
        }
    }
};
